import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import FileSystem from "components/FileSystem";
import MDTypography from "components/MDTypography";

import * as ajax from "helpers/ajax";




export default class FileSystemCommessa extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            showCommessa: true,
            switchData: {
                label: "Guarda Documentazione Gara",
                currentID: this.props.data.id,
                currentBaseRoute: "/commessa"
            }
        };
    }

    switchGaraCommessa = () => {
        let temp = this.state.switchData;
        let showCommessa=!this.state.showCommessa

        showCommessa ? temp.label = "Guarda Documentazione Gara" : temp.label = "Guarda Documentazione Commessa"
        showCommessa ? temp.currentID = this.state.data.id : temp.currentID = this.state.data.gara.id
        showCommessa ? temp.currentBaseRoute = "/commessa" : temp.currentBaseRoute = "/gara"

        this.setState({ showCommessa: showCommessa, switchData: temp });
    }

    render() {
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={this.state.data.nome}
                    backButton={this.props.backFunction}
                    //menu={(this.state.data.gara) ? [{ label: this.state.switchData.label, function: this.switchGaraCommessa }] : []}
                />
                <FileSystem
                    id={this.state.data.id}
                    baseRoute={"/commessa"}
                    subfolder={this.props.subfolder}
                />

                {(this.state.data.gara) ?
                    <>
                        <MDTypography
                            textTransform="uppercase"
                            variant={"h4"}
                            fontWeight={"bold"}
                            style={{marginTop:20}}
                        >
                            Documentazione gara
                        </MDTypography>

                        <FileSystem
                            id={this.state.data.gara.id}
                            baseRoute={"/gara"}
                            subfolder={this.props.subfolder}
                        />
                    </>

                    : null}
            </DashboardLayout>
        )
    }
}


